// reviewWriteConfig(리뷰 설정) 페이지 온보딩 투어
// 리뷰 작성·노출 관련 설정을 주제별 아코디언 섹션으로 관리하는 페이지.
import { buildSteps } from '../tourStep';

export function buildReviewWriteConfigSteps(ctx, tour) {
  return buildSteps([
    {
      id: 'welcome',
      emoji: '⚙️',
      title: '리뷰 설정에 오신 걸 환영해요!',
      text: '리뷰 작성·노출과 관련된 설정을 한곳에서 관리하는 페이지예요. 핵심만 빠르게 둘러볼게요 :)',
      attachTo: null,
    },
    {
      id: 'sections',
      emoji: '🗂️',
      title: '섹션별 설정',
      text: '설정이 주제별 <b>아코디언 섹션</b>으로 정리돼 있어요. 제목을 클릭해 펼치고 값을 바꾸면, 하단에 저장 바가 나타나 <b>한 번에 저장</b>할 수 있어요.',
      attachTo: { element: '.wbp-accordion__head', on: 'bottom' },
      beforeShow: '.wbp-accordion__head',
    },
    {
      id: 'cafe24',
      emoji: '🛍️',
      title: '카페24 연동 · 기본 작성 설정',
      text: '카페24 연동에 필요한 <b>관리자 이름·비밀번호</b> 등 기본 설정이에요. 리뷰 답글을 작성하려면 먼저 설정해 주세요.',
      attachTo: { element: '#basicWriteSettings', on: 'top' },
      beforeShow: '#basicWriteSettings',
    },
    {
      id: 'done',
      emoji: '🎉',
      title: '준비 끝!',
      text: '필요한 섹션을 펼쳐 설정해보세요. 다시 보고 싶으면 제목 옆 <b>?</b> 버튼을 누르면 돼요.',
      attachTo: null,
    },
  ], tour);
}

export default buildReviewWriteConfigSteps;
